import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ApiResponse } from '@core/interface/api-response.interface';
import { PageableResponse } from '@core/interface/pageable.interface';
import { RefId } from '@core/interface/ref-id.interface';
import { UrlBuilder } from '@core/model/url-builder';
import { CreateManagementScheduleRequestDto } from '@domain/management-schedule/dtos/create-management-schedule.request.dto';
import { ListManagementScheduleRequestDto } from '@domain/management-schedule/dtos/list-management-schedule.request.dto';
import { ManagementScheduleResponseDto } from '@domain/management-schedule/dtos/management-schedule.response.dto';
import { UpdateManagementScheduleRequestDto } from '@domain/management-schedule/dtos/update-management-schedule.request.dto';
import { UpdateStateManagementScheduleRequestDto } from '@domain/management-schedule/dtos/update-state-management-schedule.request.dto';

@Injectable({
  providedIn: 'root',
})
export class ManagementScheduleService extends UrlBuilder {
  constructor(private http: HttpClient) {
    super('management-schedule');
  }

  list(request: ListManagementScheduleRequestDto) {
    const queryUrl = `${this.getApiUrl()}/list`;
    return this.http.get<
      ApiResponse<PageableResponse<ManagementScheduleResponseDto>>
    >(queryUrl, { params: { ...request } });
  }

  show(request: RefId) {
    const { refId } = request;
    const queryUrl = `${this.getApiUrl()}/show/${refId}`;
    return this.http.get<ApiResponse<ManagementScheduleResponseDto>>(queryUrl);
  }

  create(request: CreateManagementScheduleRequestDto) {
    const queryUrl = this.getApiUrl();
    return this.http.post<ApiResponse<ManagementScheduleResponseDto>>(
      queryUrl,
      request,
    );
  }

  update(request: UpdateManagementScheduleRequestDto) {
    const { refId } = request;
    const queryUrl = `${this.getApiUrl()}/${refId}`;
    return this.http.put<ApiResponse<ManagementScheduleResponseDto>>(
      queryUrl,
      request,
    );
  }

  updateState(request: UpdateStateManagementScheduleRequestDto) {
    const { refId, enabled } = request;
    const queryUrl = `${this.getApiUrl()}/${refId}/state`;
    return this.http.patch<ApiResponse<ManagementScheduleResponseDto>>(queryUrl, {
      enabled,
    });
  }

  delete(request: RefId) {
    const { refId } = request;
    const queryUrl = `${this.getApiUrl()}/${refId}`;
    return this.http.delete<ApiResponse<void>>(queryUrl);
  }
}
